import {CountryISO2, Country, LocalizedCountry, LanguageType} from "@/types/country";
import {Locale} from "@/i18n/routing";

const countries: Record<CountryISO2, Country> = {
  "AF": {
    "names": {
      "en": "Afghanistan",
      "fr": "Afghanistan"
    },
    "ISO2": "AF",
    "ISO3": "AFG",
    "callingCode": "93"

  },
  "AL": {
    "names": {
      "en": "Albania",
      "fr": "Albanie"
    },
    "ISO2": "AL",
    "ISO3": "ALB",
    "callingCode": "355"

  },
  "DZ": {
    "names": {
      "en": "Algeria",
      "fr": "Algérie"
    },
    "ISO2": "DZ",
    "ISO3": "DZA",
    "callingCode": "213"

  },
  "AS": {
    "names": {
      "en": "American Samoa",
      "fr": "Samoa américaines"
    },
    "ISO2": "AS",
    "ISO3": "ASM",

    "callingCode": "1 684"

  },
  "AD": {
    "names": {
      "en": "Andorra",
      "fr": "Andorre"
    },
    "ISO2": "AD",
    "ISO3": "AND",

    "callingCode": "376"

  },
  "AO": {
    "names": {
      "en": "Angola",
      "fr": "Angola"
    },
    "ISO2": "AO",
    "ISO3": "AGO",

    "callingCode": "244"

  },
  "AI": {
    "names": {
      "en": "Anguilla",
      "fr": "Anguilla"
    },
    "ISO2": "AI",
    "ISO3": "AIA",

    "callingCode": "1 264"

  },
  "AQ": {
    "names": {
      "en": "Antarctica",
      "fr": "Antarctique"
    },
    "ISO2": "AQ",
    "ISO3": "ATA",

    "callingCode": "672"
  },
  "AG": {
    "names": {
      "en": "Antigua and Barbuda",
      "fr": "Antigua-et-Barbuda"
    },
    "ISO2": "AG",
    "ISO3": "ATG",

    "callingCode": "1 268"
  },
  "AR": {
    "names": {
      "en": "Argentina",
      "fr": "Argentine"
    },
    "ISO2": "AR",
    "ISO3": "ARG",

    "callingCode": "54"

  },
  "AM": {
    "names": {
      "en": "Armenia",
      "fr": "Arménie"
    },
    "ISO2": "AM",
    "ISO3": "ARM",

    "callingCode": "374"

  },
  "AW": {
    "names": {
      "en": "Aruba",
      "fr": "Aruba"
    },
    "ISO2": "AW",
    "ISO3": "ABW",

    "callingCode": "297"

  },
  "AU": {
    "names": {
      "en": "Australia",
      "fr": "Australie"
    },
    "ISO2": "AU",
    "ISO3": "AUS",

    "callingCode": "61"
  },
  "AT": {
    "names": {
      "en": "Austria",
      "fr": "Autriche"
    },
    "ISO2": "AT",
    "ISO3": "AUT",

    "callingCode": "43"

  },
  "AZ": {
    "names": {
      "en": "Azerbaijan",
      "fr": "Azerbaïdjan"
    },
    "ISO2": "AZ",
    "ISO3": "AZE",

    "callingCode": "994"

  },
  "BS": {
    "names": {
      "en": "Bahamas",
      "fr": "Bahamas"
    },
    "ISO2": "BS",
    "ISO3": "BHS",

    "callingCode": "1 242"

  },
  "BH": {
    "names": {
      "en": "Bahrain",
      "fr": "Bahreïn"
    },
    "ISO2": "BH",
    "ISO3": "BHR",

    "callingCode": "973"

  },
  "BD": {
    "names": {
      "en": "Bangladesh",
      "fr": "Bangladesh"
    },
    "ISO2": "BD",
    "ISO3": "BGD",

    "callingCode": "880"

  },
  "BB": {
    "names": {
      "en": "Barbados",
      "fr": "Barbade"
    },
    "ISO2": "BB",
    "ISO3": "BRB",

    "callingCode": "1 246"

  },
  "BY": {
    "names": {
      "en": "Belarus",
      "fr": "Biélorussie"
    },
    "ISO2": "BY",
    "ISO3": "BLR",

    "callingCode": "375"

  },
  "BE": {
    "names": {
      "en": "Belgium",
      "fr": "Belgique"
    },
    "ISO2": "BE",
    "ISO3": "BEL",

    "callingCode": "32"

  },
  "BZ": {
    "names": {
      "en": "Belize",
      "fr": "Belize"
    },
    "ISO2": "BZ",
    "ISO3": "BLZ",

    "callingCode": "501"

  },
  "BJ": {
    "names": {
      "en": "Benin",
      "fr": "Bénin"
    },
    "ISO2": "BJ",
    "ISO3": "BEN",

    "callingCode": "229"

  },
  "BM": {
    "names": {
      "en": "Bermuda",
      "fr": "Bermudes"
    },
    "ISO2": "BM",
    "ISO3": "BMU",

    "callingCode": "1 441"

  },
  "BT": {
    "names": {
      "en": "Bhutan",
      "fr": "Bhoutan"
    },
    "ISO2": "BT",
    "ISO3": "BTN",

    "callingCode": "975"

  },
  "BO": {
    "names": {
      "en": "Bolivia",
      "fr": "Bolivie"
    },
    "ISO2": "BO",
    "ISO3": "BOL",

    "callingCode": "591"

  },
  "BA": {
    "names": {
      "en": "Bosnia and Herzegovina",
      "fr": "Bosnie-Herzégovine"
    },
    "ISO2": "BA",
    "ISO3": "BIH",

    "callingCode": "387"

  },
  "BW": {
    "names": {
      "en": "Botswana",
      "fr": "Botswana"
    },
    "ISO2": "BW",
    "ISO3": "BWA",

    "callingCode": "267"

  },
  "BR": {
    "names": {
      "en": "Brazil",
      "fr": "Brésil"
    },
    "ISO2": "BR",
    "ISO3": "BRA",

    "callingCode": "55"

  },
  "VG": {
    "names": {
      "en": "British Virgin Islands",
      "fr": "Îles Vierges britanniques"
    },
    "ISO2": "VG",
    "ISO3": "VGB",

    "callingCode": "1 284"

  },
  "BN": {
    "names": {
      "en": "Brunei",
      "fr": "Brunei"
    },
    "ISO2": "BN",
    "ISO3": "BRN",

    "callingCode": "673"

  },
  "BG": {
    "names": {
      "en": "Bulgaria",
      "fr": "Bulgarie"
    },
    "ISO2": "BG",
    "ISO3": "BGR",

    "callingCode": "359"

  },
  "BF": {
    "names": {
      "en": "Burkina Faso",
      "fr": "Burkina Faso"
    },
    "ISO2": "BF",
    "ISO3": "BFA",

    "callingCode": "226"

  },
  "MM": {
    "names": {
      "en": "Burma (Myanmar)",
      "fr": "Birmanie (Myanmar)"
    },
    "ISO2": "MM",
    "ISO3": "MMR",

    "callingCode": "95"

  },
  "BI": {
    "names": {
      "en": "Burundi",
      "fr": "Burundi"
    },
    "ISO2": "BI",
    "ISO3": "BDI",

    "callingCode": "257"

  },
  "KH": {
    "names": {
      "en": "Cambodia",
      "fr": "Cambodge"
    },
    "ISO2": "KH",
    "ISO3": "KHM",

    "callingCode": "855"

  },
  "CM": {
    "names": {
      "en": "Cameroon",
      "fr": "Cameroun"
    },
    "ISO2": "CM",
    "ISO3": "CMR",

    "callingCode": "237"

  },
  "CA": {
    "names": {
      "en": "Canada",
      "fr": "Canada"
    },
    "ISO2": "CA",
    "ISO3": "CAN",
    "callingCode": "1"
  },
  "CV": {
    "names": {
      "en": "Cape Verde",
      "fr": "Cap-Vert"
    },
    "ISO2": "CV",
    "ISO3": "CPV",

    "callingCode": "238"

  },
  "KY": {
    "names": {
      "en": "Cayman Islands",
      "fr": "Îles Caïmans"
    },
    "ISO2": "KY",
    "ISO3": "CYM",

    "callingCode": "1 345"

  },
  "CF": {
    "names": {
      "en": "Central African Republic",
      "fr": "République centrafricaine"
    },
    "ISO2": "CF",
    "ISO3": "CAF",

    "callingCode": "236"

  },
  "TD": {
    "names": {
      "en": "Chad",
      "fr": "Tchad"
    },
    "ISO2": "TD",
    "ISO3": "TCD",

    "callingCode": "235"

  },
  "CL": {
    "names": {
      "en": "Chile",
      "fr": "Chili"
    },
    "ISO2": "CL",
    "ISO3": "CHL",

    "callingCode": "56"

  },
  "CN": {
    "names": {
      "en": "China",
      "fr": "Chine"
    },
    "ISO2": "CN",
    "ISO3": "CHN",

    "callingCode": "86"
  },
  "CX": {
    "names": {
      "en": "Christmas Island",
      "fr": "Île Christmas"
    },
    "ISO2": "CX",
    "ISO3": "CXR",

    "callingCode": "61"

  },
  "CC": {
    "names": {
      "en": "Cocos (Keeling) Islands",
      "fr": "Îles Cocos (Keeling)"
    },
    "ISO2": "CC",
    "ISO3": "CCK",

    "callingCode": "61"

  },
  "CO": {
    "names": {
      "en": "Colombia",
      "fr": "Colombie"
    },
    "ISO2": "CO",
    "ISO3": "COL",

    "callingCode": "57"

  },
  "KM": {
    "names": {
      "en": "Comoros",
      "fr": "Comores"
    },
    "ISO2": "KM",
    "ISO3": "COM",

    "callingCode": "269"

  },
  "CG": {
    "names": {
      "en": "Republic of the Congo",
      "fr": "République du Congo"
    },
    "ISO2": "CG",
    "ISO3": "COG",

    "callingCode": "242"

  },
  "CK": {
    "names": {
      "en": "Cook Islands",
      "fr": "Îles Cook"
    },
    "ISO2": "CK",
    "ISO3": "COK",

    "callingCode": "682"

  },
  "CR": {
    "names": {
      "en": "Costa Rica",
      "fr": "Costa Rica"
    },
    "ISO2": "CR",
    "ISO3": "CRC",

    "callingCode": "506"

  },
  "HR": {
    "names": {
      "en": "Croatia",
      "fr": "Croatie"
    },
    "ISO2": "HR",
    "ISO3": "HRV",

    "callingCode": "385"

  },
  "CU": {
    "names": {
      "en": "Cuba",
      "fr": "Cuba"
    },
    "ISO2": "CU",
    "ISO3": "CUB",

    "callingCode": "53"

  },
  "CY": {
    "names": {
      "en": "Cyprus",
      "fr": "Chypre"
    },
    "ISO2": "CY",
    "ISO3": "CYP",

    "callingCode": "357"

  },
  "CZ": {
    "names": {
      "en": "Czech Republic",
      "fr": "République tchèque"
    },
    "ISO2": "CZ",
    "ISO3": "CZE",

    "callingCode": "420"

  },
  "CD": {
    "names": {
      "en": "Democratic Republic of the Congo",
      "fr": "République démocratique du Congo"
    },
    "ISO2": "CD",
    "ISO3": "COD",

    "callingCode": "243"

  },
  "DK": {
    "names": {
      "en": "Denmark",
      "fr": "Danemark"
    },
    "ISO2": "DK",
    "ISO3": "DNK",

    "callingCode": "45"

  },
  "DG": {
    "names": {
      "en": "Diego Garcia",
      "fr": "Diego Garcia"
    },
    "ISO2": "DG",
    "ISO3": "DGA",

    "callingCode": "246"

  },
  "DJ": {
    "names": {
      "en": "Djibouti",
      "fr": "Djibouti"
    },
    "ISO2": "DJ",
    "ISO3": "DJI",

    "callingCode": "253"
  },
  "DM": {
    "names": {
      "en": "Dominica",
      "fr": "Dominique"
    },
    "ISO2": "DM",
    "ISO3": "DMA",

    "callingCode": "1 767"

  },
  "DO": {
    "names": {
      "en": "Dominican Republic",
      "fr": "République dominicaine"
    },
    "ISO2": "DO",
    "ISO3": "DOM",
    "callingCode": "1 809"
  },
  "EC": {
    "names": {
      "en": "Ecuador",
      "fr": "Équateur"
    },
    "ISO2": "EC",
    "ISO3": "ECU",

    "callingCode": "593"

  },
  "EG": {
    "names": {
      "en": "Egypt",
      "fr": "Égypte"
    },
    "ISO2": "EG",
    "ISO3": "EGY",

    "callingCode": "20"

  },
  "SV": {
    "names": {
      "en": "El Salvador",
      "fr": "Salvador"
    },
    "ISO2": "SV",
    "ISO3": "SLV",

    "callingCode": "503"

  },
  "GQ": {
    "names": {
      "en": "Equatorial Guinea",
      "fr": "Guinée équatoriale"
    },
    "ISO2": "GQ",
    "ISO3": "GNQ",

    "callingCode": "240"

  },
  "ER": {
    "names": {
      "en": "Eritrea",
      "fr": "Érythrée"
    },
    "ISO2": "ER",
    "ISO3": "ERI",

    "callingCode": "291"

  },
  "EE": {
    "names": {
      "en": "Estonia",
      "fr": "Estonie"
    },
    "ISO2": "EE",
    "ISO3": "EST",

    "callingCode": "372"

  },
  "ET": {
    "names": {
      "en": "Ethiopia",
      "fr": "Éthiopie"
    },
    "ISO2": "ET",
    "ISO3": "ETH",

    "callingCode": "251"

  },
  "FK": {
    "names": {
      "en": "Falkland Islands",
      "fr": "Îles Malouines"
    },
    "ISO2": "FK",
    "ISO3": "FLK",

    "callingCode": "500"

  },
  "FO": {
    "names": {
      "en": "Faroe Islands",
      "fr": "Îles Féroé"
    },
    "ISO2": "FO",
    "ISO3": "FRO",

    "callingCode": "298"

  },
  "FJ": {
    "names": {
      "en": "Fiji",
      "fr": "Fidji"
    },
    "ISO2": "FJ",
    "ISO3": "FJI",

    "callingCode": "679"

  },
  "FI": {
    "names": {
      "en": "Finland",
      "fr": "Finlande"
    },
    "ISO2": "FI",
    "ISO3": "FIN",

    "callingCode": "358"

  },
  "FR": {
    "names": {
      "en": "France",
      "fr": "France"
    },
    "ISO2": "FR",
    "ISO3": "FRA",

    "callingCode": "33"

  },
  "GF": {
    "names": {
      "en": "French Guiana",
      "fr": "Guyane française"
    },
    "ISO2": "GF",
    "ISO3": "GUF",

    "callingCode": "594"

  },
  "PF": {
    "names": {
      "en": "French Polynesia",
      "fr": "Polynésie française"
    },
    "ISO2": "PF",
    "ISO3": "PYF",

    "callingCode": "689"

  },
  "GA": {
    "names": {
      "en": "Gabon",
      "fr": "Gabon"
    },
    "ISO2": "GA",
    "ISO3": "GAB",

    "callingCode": "241"

  },
  "GM": {
    "names": {
      "en": "Gambia",
      "fr": "Gambie"
    },
    "ISO2": "GM",
    "ISO3": "GMB",

    "callingCode": "220"

  },
  "GE": {
    "names": {
      "en": "Georgia",
      "fr": "Géorgie"
    },
    "ISO2": "GE",
    "ISO3": "GEO",

    "callingCode": "995"

  },
  "DE": {
    "names": {
      "en": "Germany",
      "fr": "Allemagne"
    },
    "ISO2": "DE",
    "ISO3": "DEU",

    "callingCode": "49"

  },
  "GH": {
    "names": {
      "en": "Ghana",
      "fr": "Ghana"
    },
    "ISO2": "GH",
    "ISO3": "GHA",

    "callingCode": "233"

  },
  "GI": {
    "names": {
      "en": "Gibraltar",
      "fr": "Gibraltar"
    },
    "ISO2": "GI",
    "ISO3": "GIB",

    "callingCode": "350"

  },
  "GR": {
    "names": {
      "en": "Greece",
      "fr": "Grèce"
    },
    "ISO2": "GR",
    "ISO3": "GRC",

    "callingCode": "30"

  },
  "GL": {
    "names": {
      "en": "Greenland",
      "fr": "Groenland"
    },
    "ISO2": "GL",
    "ISO3": "GRL",

    "callingCode": "299"

  },
  "GD": {
    "names": {
      "en": "Grenada",
      "fr": "Grenade"
    },
    "ISO2": "GD",
    "ISO3": "GRD",

    "callingCode": "1 473"

  },
  "GP": {
    "names": {
      "en": "Guadeloupe",
      "fr": "Guadeloupe"
    },
    "ISO2": "GP",
    "ISO3": "GLP",

    "callingCode": "590"

  },
  "GU": {
    "names": {
      "en": "Guam",
      "fr": "Guam"
    },
    "ISO2": "GU",
    "ISO3": "GUM",

    "callingCode": "1 671"

  },
  "GT": {
    "names": {
      "en": "Guatemala",
      "fr": "Guatemala"
    },
    "ISO2": "GT",
    "ISO3": "GTM",

    "callingCode": "502"

  },
  "GN": {
    "names": {
      "en": "Guinea",
      "fr": "Guinée"
    },
    "ISO2": "GN",
    "ISO3": "GIN",

    "callingCode": "224"

  },
  "GW": {
    "names": {
      "en": "Guinea-Bissau",
      "fr": "Guinée-Bissau"
    },
    "ISO2": "GW",
    "ISO3": "GNB",

    "callingCode": "245"

  },
  "GY": {
    "names": {
      "en": "Guyana",
      "fr": "Guyana"
    },
    "ISO2": "GY",
    "ISO3": "GUY",

    "callingCode": "592"

  },
  "HT": {
    "names": {
      "en": "Haiti",
      "fr": "Haïti"
    },
    "ISO2": "HT",
    "ISO3": "HTI",

    "callingCode": "509"

  },
  "VA": {
    "names": {
      "en": "Holy See (Vatican City)",
      "fr": "Saint-Siège (Cité du Vatican)"
    },
    "ISO2": "VA",
    "ISO3": "VAT",

    "callingCode": "39"

  },
  "HN": {
    "names": {
      "en": "Honduras",
      "fr": "Honduras"
    },
    "ISO2": "HN",
    "ISO3": "HND",

    "callingCode": "504"

  },
  "HK": {
    "names": {
      "en": "Hong Kong",
      "fr": "Hong Kong"
    },
    "ISO2": "HK",
    "ISO3": "HKG",

    "callingCode": "852"

  },
  "HU": {
    "names": {
      "en": "Hungary",
      "fr": "Hongrie"
    },
    "ISO2": "HU",
    "ISO3": "HUN",

    "callingCode": "36"

  },
  "IS": {
    "names": {
      "en": "Iceland",
      "fr": "Islande"
    },
    "ISO2": "IS",
    "ISO3": "IS",

    "callingCode": "354"

  },
  "IN": {
    "names": {
      "en": "India",
      "fr": "Inde"
    },
    "ISO2": "IN",
    "ISO3": "IND",

    "callingCode": "91"
  },
  "ID": {
    "names": {
      "en": "Indonesia",
      "fr": "Indonésie"
    },
    "ISO2": "ID",
    "ISO3": "IDN",

    "callingCode": "62"

  },
  "IR": {
    "names": {
      "en": "Iran",
      "fr": "Iran"
    },
    "ISO2": "IR",
    "ISO3": "IRN",

    "callingCode": "98"
  },
  "IQ": {
    "names": {
      "en": "Iraq",
      "fr": "Irak"
    },
    "ISO2": "IQ",
    "ISO3": "IRQ",

    "callingCode": "964"

  },
  "IE": {
    "names": {
      "en": "Ireland",
      "fr": "Irlande"
    },
    "ISO2": "IE",
    "ISO3": "IRL",

    "callingCode": "353"

  },
  "IM": {
    "names": {
      "en": "Isle of Man",
      "fr": "Île de Man"
    },
    "ISO2": "IM",
    "ISO3": "IMN",

    "callingCode": "44"

  },
  "IL": {
    "names": {
      "en": "Israel",
      "fr": "Israël"
    },
    "ISO2": "IL",
    "ISO3": "ISR",

    "callingCode": "972"

  },
  "IT": {
    "names": {
      "en": "Italy",
      "fr": "Italie"
    },
    "ISO2": "IT",
    "ISO3": "ITA",

    "callingCode": "39"

  },
  "CI": {
    "names": {
      "en": "Ivory Coast",
      "fr": "Côte d'Ivoire"
    },
    "ISO2": "CI",
    "ISO3": "CIV",

    "callingCode": "225"

  },
  "JM": {
    "names": {
      "en": "Jamaica",
      "fr": "Jamaïque"
    },
    "ISO2": "JM",
    "ISO3": "JAM",

    "callingCode": "1 876"

  },
  "JP": {
    "names": {
      "en": "Japan",
      "fr": "Japon"
    },
    "ISO2": "JP",
    "ISO3": "JPN",

    "callingCode": "81"
  },
  "JE": {
    "names": {
      "en": "Jersey",
      "fr": "Jersey"
    },
    "ISO2": "JE",
    "ISO3": "JEY",
    "callingCode": "44"
  },
  "JO": {
    "names": {
      "en": "Jordan",
      "fr": "Jordanie"
    },
    "ISO2": "JO",
    "ISO3": "JOR",

    "callingCode": "962"

  },
  "KZ": {
    "names": {
      "en": "Kazakhstan",
      "fr": "Kazakhstan"
    },
    "ISO2": "KZ",
    "ISO3": "KAZ",

    "callingCode": "7"

  },
  "KE": {
    "names": {
      "en": "Kenya",
      "fr": "Kenya"
    },
    "ISO2": "KE",
    "ISO3": "KEN",

    "callingCode": "254"
  },
  "KI": {
    "names": {
      "en": "Kiribati",
      "fr": "Kiribati"
    },
    "ISO2": "KI",
    "ISO3": "KIR",

    "callingCode": "686"

  },
  "KW": {
    "names": {
      "en": "Kuwait",
      "fr": "Koweït"
    },
    "ISO2": "KW",
    "ISO3": "KWT",

    "callingCode": "965"

  },
  "KG": {
    "names": {
      "en": "Kyrgyzstan",
      "fr": "Kirghizistan"
    },
    "ISO2": "KG",
    "ISO3": "KGZ",

    "callingCode": "996"

  },
  "LA": {
    "names": {
      "en": "Laos",
      "fr": "Laos"
    },
    "ISO2": "LA",
    "ISO3": "LAO",

    "callingCode": "856"

  },
  "LV": {
    "names": {
      "en": "Latvia",
      "fr": "Lettonie"
    },
    "ISO2": "LV",
    "ISO3": "LVA",

    "callingCode": "371"

  },
  "LB": {
    "names": {
      "en": "Lebanon",
      "fr": "Liban"
    },
    "ISO2": "LB",
    "ISO3": "LBN",

    "callingCode": "961"

  },
  "LS": {
    "names": {
      "en": "Lesotho",
      "fr": "Lesotho"
    },
    "ISO2": "LS",
    "ISO3": "LSO",

    "callingCode": "266"

  },
  "LR": {
    "names": {
      "en": "Liberia",
      "fr": "Liberia"
    },
    "ISO2": "LR",
    "ISO3": "LBR",

    "callingCode": "231"

  },
  "LY": {
    "names": {
      "en": "Libya",
      "fr": "Libye"
    },
    "ISO2": "LY",
    "ISO3": "LBY",

    "callingCode": "218"

  },
  "LI": {
    "names": {
      "en": "Liechtenstein",
      "fr": "Liechtenstein"
    },
    "ISO2": "LI",
    "ISO3": "LIE",

    "callingCode": "423"

  },
  "LT": {
    "names": {
      "en": "Lithuania",
      "fr": "Lituanie"
    },
    "ISO2": "LT",
    "ISO3": "LTU",

    "callingCode": "370"

  },
  "LU": {
    "names": {
      "en": "Luxembourg",
      "fr": "Luxembourg"
    },
    "ISO2": "LU",
    "ISO3": "LUX",

    "callingCode": "352"

  },
  "MO": {
    "names": {
      "en": "Macau",
      "fr": "Macao"
    },
    "ISO2": "MO",
    "ISO3": "MAC",

    "callingCode": "853"

  },
  "MK": {
    "names": {
      "en": "Macedonia",
      "fr": "Macédoine"
    },
    "ISO2": "MK",
    "ISO3": "MKD",

    "callingCode": "389"

  },
  "MG": {
    "names": {
      "en": "Madagascar",
      "fr": "Madagascar"
    },
    "ISO2": "MG",
    "ISO3": "MDG",

    "callingCode": "261"

  },
  "MW": {
    "names": {
      "en": "Malawi",
      "fr": "Malawi"
    },
    "ISO2": "MW",
    "ISO3": "MWI",

    "callingCode": "265"

  },
  "MY": {
    "names": {
      "en": "Malaysia",
      "fr": "Malaisie"
    },
    "ISO2": "MY",
    "ISO3": "MYS",

    "callingCode": "60"

  },
  "MV": {
    "names": {
      "en": "Maldives",
      "fr": "Maldives"
    },
    "ISO2": "MV",
    "ISO3": "MDV",

    "callingCode": "960"

  },
  "ML": {
    "names": {
      "en": "Mali",
      "fr": "Mali"
    },
    "ISO2": "ML",
    "ISO3": "MLI",

    "callingCode": "223"

  },
  "MT": {
    "names": {
      "en": "Malta",
      "fr": "Malte"
    },
    "ISO2": "MT",
    "ISO3": "MLT",

    "callingCode": "356"

  },
  "MH": {
    "names": {
      "en": "Marshall Islands",
      "fr": "Îles Marshall"
    },
    "ISO2": "MH",
    "ISO3": "MHL",

    "callingCode": "692"

  },
  "MQ": {
    "names": {
      "en": "Martinique",
      "fr": "Martinique"
    },
    "ISO2": "MQ",
    "ISO3": "MTQ",

    "callingCode": "596"

  },
  "MR": {
    "names": {
      "en": "Mauritania",
      "fr": "Mauritanie"
    },
    "ISO2": "MR",
    "ISO3": "MRT",

    "callingCode": "222"

  },
  "MU": {
    "names": {
      "en": "Mauritius",
      "fr": "Maurice"
    },
    "ISO2": "MU",
    "ISO3": "MUS",

    "callingCode": "230"

  },
  "YT": {
    "names": {
      "en": "Mayotte",
      "fr": "Mayotte"
    },
    "ISO2": "YT",
    "ISO3": "MYT",

    "callingCode": "262"

  },
  "MX": {
    "names": {
      "en": "Mexico",
      "fr": "Mexique"
    },
    "ISO2": "MX",
    "ISO3": "MEX",

    "callingCode": "52"
  },
  "FM": {
    "names": {
      "en": "Micronesia",
      "fr": "Micronésie"
    },
    "ISO2": "FM",
    "ISO3": "FSM",

    "callingCode": "691"

  },
  "MD": {
    "names": {
      "en": "Moldova",
      "fr": "Moldavie"
    },
    "ISO2": "MD",
    "ISO3": "MDA",

    "callingCode": "373"

  },
  "MC": {
    "names": {
      "en": "Monaco",
      "fr": "Monaco"
    },
    "ISO2": "MC",
    "ISO3": "MCO",

    "callingCode": "377"

  },
  "MN": {
    "names": {
      "en": "Mongolia",
      "fr": "Mongolie"
    },
    "ISO2": "MN",
    "ISO3": "MNG",

    "callingCode": "976"

  },
  "ME": {
    "names": {
      "en": "Montenegro",
      "fr": "Monténégro"
    },
    "ISO2": "ME",
    "ISO3": "MNE",

    "callingCode": "382"

  },
  "MS": {
    "names": {
      "en": "Montserrat",
      "fr": "Montserrat"
    },
    "ISO2": "MS",
    "ISO3": "MSR",

    "callingCode": "1 664"

  },
  "MA": {
    "names": {
      "en": "Morocco",
      "fr": "Maroc"
    },
    "ISO2": "MA",
    "ISO3": "MAR",

    "callingCode": "212"
  },
  "MZ": {
    "names": {
      "en": "Mozambique",
      "fr": "Mozambique"
    },
    "ISO2": "MZ",
    "ISO3": "MOZ",

    "callingCode": "258"

  },
  "NA": {
    "names": {
      "en": "Namibia",
      "fr": "Namibie"
    },
    "ISO2": "NA",
    "ISO3": "NAM",

    "callingCode": "264"

  },
  "NR": {
    "names": {
      "en": "Nauru",
      "fr": "Nauru"
    },
    "ISO2": "NR",
    "ISO3": "NRU",

    "callingCode": "674"

  },
  "NP": {
    "names": {
      "en": "Nepal",
      "fr": "Népal"
    },
    "ISO2": "NP",
    "ISO3": "NPL",

    "callingCode": "977"

  },
  "NL": {
    "names": {
      "en": "Netherlands",
      "fr": "Pays-Bas"
    },
    "ISO2": "NL",
    "ISO3": "NLD",

    "callingCode": "31"

  },
  "NC": {
    "names": {
      "en": "New Caledonia",
      "fr": "Nouvelle-Calédonie"
    },
    "ISO2": "NC",
    "ISO3": "NCL",

    "callingCode": "687"

  },
  "NZ": {
    "names": {
      "en": "New Zealand",
      "fr": "Nouvelle-Zélande"
    },
    "ISO2": "NZ",
    "ISO3": "NZL",

    "callingCode": "64"
  },
  "NI": {
    "names": {
      "en": "Nicaragua",
      "fr": "Nicaragua"
    },
    "ISO2": "NI",
    "ISO3": "NIC",

    "callingCode": "505"

  },
  "NE": {
    "names": {
      "en": "Niger",
      "fr": "Niger"
    },
    "ISO2": "NE",
    "ISO3": "NER",

    "callingCode": "227"

  },
  "NG": {
    "names": {
      "en": "Nigeria",
      "fr": "Nigeria"
    },
    "ISO2": "NG",
    "ISO3": "NGA",

    "callingCode": "234"

  },
  "NU": {
    "names": {
      "en": "Niue",
      "fr": "Niue"
    },
    "ISO2": "NU",
    "ISO3": "NIU",

    "callingCode": "683"

  },
  "NF": {
    "names": {
      "en": "Norfolk Island",
      "fr": "Île Norfolk"
    },
    "ISO2": "NF",
    "ISO3": "NFK",

    "callingCode": "672"

  },
  "KP": {
    "names": {
      "en": "North Korea",
      "fr": "Corée du Nord"
    },
    "ISO2": "KP",
    "ISO3": "PRK",

    "callingCode": "850"

  },
  "MP": {
    "names": {
      "en": "Northern Mariana Islands",
      "fr": "Îles Mariannes du Nord"
    },
    "ISO2": "MP",
    "ISO3": "MNP",

    "callingCode": "1 670"

  },
  "NO": {
    "names": {
      "en": "Norway",
      "fr": "Norvège"
    },
    "ISO2": "NO",
    "ISO3": "NOR",

    "callingCode": "47"

  },
  "OM": {
    "names": {
      "en": "Oman",
      "fr": "Oman"
    },
    "ISO2": "OM",
    "ISO3": "OMN",

    "callingCode": "968"

  },
  "PK": {
    "names": {
      "en": "Pakistan",
      "fr": "Pakistan"
    },
    "ISO2": "PK",
    "ISO3": "PAK",

    "callingCode": "92"

  },
  "PW": {
    "names": {
      "en": "Palau",
      "fr": "Palaos"
    },
    "ISO2": "PW",
    "ISO3": "PLW",

    "callingCode": "680"

  },
  "PS": {
    "names": {
      "en": "Palestine",
      "fr": "Palestine"
    },
    "ISO2": "PS",
    "ISO3": "PSE",

    "callingCode": "970"

  },
  "PA": {
    "names": {
      "en": "Panama",
      "fr": "Panama"
    },
    "ISO2": "PA",
    "ISO3": "PAN",

    "callingCode": "507"

  },
  "PG": {
    "names": {
      "en": "Papua New Guinea",
      "fr": "Papouasie-Nouvelle-Guinée"
    },
    "ISO2": "PG",
    "ISO3": "PNG",

    "callingCode": "675"

  },
  "PY": {
    "names": {
      "en": "Paraguay",
      "fr": "Paraguay"
    },
    "ISO2": "PY",
    "ISO3": "PRY",

    "callingCode": "595"

  },
  "PE": {
    "names": {
      "en": "Peru",
      "fr": "Pérou"
    },
    "ISO2": "PE",
    "ISO3": "PER",

    "callingCode": "51"

  },
  "PH": {
    "names": {
      "en": "Philippines",
      "fr": "Philippines"
    },
    "ISO2": "PH",
    "ISO3": "PHL",

    "callingCode": "63"

  },
  "PN": {
    "names": {
      "en": "Pitcairn Islands",
      "fr": "Îles Pitcairn"
    },
    "ISO2": "PN",
    "ISO3": "PCN",

    "callingCode": "870"

  },
  "PL": {
    "names": {
      "en": "Poland",
      "fr": "Pologne"
    },
    "ISO2": "PL",
    "ISO3": "POL",

    "callingCode": "48"

  },
  "PT": {
    "names": {
      "en": "Portugal",
      "fr": "Portugal"
    },
    "ISO2": "PT",
    "ISO3": "PRT",

    "callingCode": "351"

  },
  "PR": {
    "names": {
      "en": "Puerto Rico",
      "fr": "Porto Rico"
    },
    "ISO2": "PR",
    "ISO3": "PRI",
    "callingCode": "1 787"
  },
  "QA": {
    "names": {
      "en": "Qatar",
      "fr": "Qatar"
    },
    "ISO2": "QA",
    "ISO3": "QAT",

    "callingCode": "974"

  },
  "RE": {
    "names": {
      "en": "Reunion Island",
      "fr": "La Réunion"
    },
    "ISO2": "RE",
    "ISO3": "REU",

    "callingCode": "262"

  },
  "RO": {
    "names": {
      "en": "Romania",
      "fr": "Roumanie"
    },
    "ISO2": "RO",
    "ISO3": "ROU",

    "callingCode": "40"

  },
  "RU": {
    "names": {
      "en": "Russia",
      "fr": "Russie"
    },
    "ISO2": "RU",
    "ISO3": "RUS",

    "callingCode": "7"

  },
  "RW": {
    "names": {
      "en": "Rwanda",
      "fr": "Rwanda"
    },
    "ISO2": "RW",
    "ISO3": "RWA",

    "callingCode": "250"

  },
  "BL": {
    "names": {
      "en": "Saint Barthelemy",
      "fr": "Saint-Barthélemy"
    },
    "ISO2": "BL",
    "ISO3": "BLM",

    "callingCode": "590"

  },
  "SH": {
    "names": {
      "en": "Saint Helena",
      "fr": "Sainte-Hélène"
    },
    "ISO2": "SH",
    "ISO3": "SHN",

    "callingCode": "290"

  },
  "KN": {
    "names": {
      "en": "Saint Kitts and Nevis",
      "fr": "Saint-Kitts-et-Nevis"
    },
    "ISO2": "KN",
    "ISO3": "KNA",

    "callingCode": "1 869"

  },
  "LC": {
    "names": {
      "en": "Saint Lucia",
      "fr": "Sainte-Lucie"
    },
    "ISO2": "LC",
    "ISO3": "LCA",

    "callingCode": "1 758"

  },
  "MF": {
    "names": {
      "en": "Saint Martin",
      "fr": "Saint-Martin"
    },
    "ISO2": "MF",
    "ISO3": "MAF",

    "callingCode": "590"

  },
  "PM": {
    "names": {
      "en": "Saint Pierre and Miquelon",
      "fr": "Saint-Pierre-et-Miquelon"
    },
    "ISO2": "PM",
    "ISO3": "SPM",

    "callingCode": "508"

  },
  "VC": {
    "names": {
      "en": "Saint Vincent and the Grenadines",
      "fr": "Saint-Vincent-et-les-Grenadines"
    },
    "ISO2": "VC",
    "ISO3": "VCT",

    "callingCode": "1 784"

  },
  "WS": {
    "names": {
      "en": "Samoa",
      "fr": "Samoa"
    },
    "ISO2": "WS",
    "ISO3": "WSM",

    "callingCode": "685"

  },
  "SM": {
    "names": {
      "en": "San Marino",
      "fr": "Saint-Marin"
    },
    "ISO2": "SM",
    "ISO3": "SMR",

    "callingCode": "378"

  },
  "ST": {
    "names": {
      "en": "Sao Tome and Principe",
      "fr": "Sao Tomé-et-Principe"
    },
    "ISO2": "ST",
    "ISO3": "STP",

    "callingCode": "239"

  },
  "SA": {
    "names": {
      "en": "Saudi Arabia",
      "fr": "Arabie saoudite"
    },
    "ISO2": "SA",
    "ISO3": "SAU",

    "callingCode": "966"

  },
  "SN": {
    "names": {
      "en": "Senegal",
      "fr": "Sénégal"
    },
    "ISO2": "SN",
    "ISO3": "SEN",

    "callingCode": "221"

  },
  "RS": {
    "names": {
      "en": "Serbia",
      "fr": "Serbie"
    },
    "ISO2": "RS",
    "ISO3": "SRB",

    "callingCode": "381"

  },
  "SC": {
    "names": {
      "en": "Seychelles",
      "fr": "Seychelles"
    },
    "ISO2": "SC",
    "ISO3": "SYC",

    "callingCode": "248"

  },
  "SL": {
    "names": {
      "en": "Sierra Leone",
      "fr": "Sierra Leone"
    },
    "ISO2": "SL",
    "ISO3": "SLE",

    "callingCode": "232"

  },
  "SG": {
    "names": {
      "en": "Singapore",
      "fr": "Singapour"
    },
    "ISO2": "SG",
    "ISO3": "SGP",

    "callingCode": "65"

  },
  "SX": {
    "names": {
      "en": "Sint Maarten",
      "fr": "Saint-Martin"
    },
    "ISO2": "SX",
    "ISO3": "SXM",

    "callingCode": "1 721"

  },
  "SK": {
    "names": {
      "en": "Slovakia",
      "fr": "Slovaquie"
    },
    "ISO2": "SK",
    "ISO3": "SVK",

    "callingCode": "421"

  },
  "SI": {
    "names": {
      "en": "Slovenia",
      "fr": "Slovénie"
    },
    "ISO2": "SI",
    "ISO3": "SVN",

    "callingCode": "386"

  },
  "SB": {
    "names": {
      "en": "Solomon Islands",
      "fr": "Îles Salomon"
    },
    "ISO2": "SB",
    "ISO3": "SLB",

    "callingCode": "677"

  },
  "SO": {
    "names": {
      "en": "Somalia",
      "fr": "Somalie"
    },
    "ISO2": "SO",
    "ISO3": "SOM",

    "callingCode": "252"

  },
  "ZA": {
    "names": {
      "en": "South Africa",
      "fr": "Afrique du Sud"
    },
    "ISO2": "ZA",
    "ISO3": "ZAF",
    "callingCode": "27"
  },
  "KR": {
    "names": {
      "en": "South Korea",
      "fr": "Corée du Sud"
    },
    "ISO2": "KR",
    "ISO3": "KOR",

    "callingCode": "82"

  },
  "SS": {
    "names": {
      "en": "South Sudan",
      "fr": "Soudan du Sud"
    },
    "ISO2": "SS",
    "ISO3": "SSD",

    "callingCode": "211"

  },
  "ES": {
    "names": {
      "en": "Spain",
      "fr": "Espagne"
    },
    "ISO2": "ES",
    "ISO3": "ESP",

    "callingCode": "34"

  },
  "LK": {
    "names": {
      "en": "Sri Lanka",
      "fr": "Sri Lanka"
    },
    "ISO2": "LK",
    "ISO3": "LKA",

    "callingCode": "94"

  },
  "SD": {
    "names": {
      "en": "Sudan",
      "fr": "Soudan"
    },
    "ISO2": "SD",
    "ISO3": "SDN",

    "callingCode": "249"

  },
  "SR": {
    "names": {
      "en": "Suriname",
      "fr": "Suriname"
    },
    "ISO2": "SR",
    "ISO3": "SUR",

    "callingCode": "597"

  },
  "SJ": {
    "names": {
      "en": "Svalbard",
      "fr": "Svalbard"
    },
    "ISO2": "SJ",
    "ISO3": "SJM",

    "callingCode": "47"

  },
  "SZ": {
    "names": {
      "en": "Swaziland",
      "fr": "Eswatini"
    },
    "ISO2": "SZ",
    "ISO3": "SWZ",

    "callingCode": "268"

  },
  "SE": {
    "names": {
      "en": "Sweden",
      "fr": "Suède"
    },
    "ISO2": "SE",
    "ISO3": "SWE",

    "callingCode": "46"

  },
  "CH": {
    "names": {
      "en": "Switzerland",
      "fr": "Suisse"
    },
    "ISO2": "CH",
    "ISO3": "CHE",

    "callingCode": "41"

  },
  "SY": {
    "names": {
      "en": "Syria",
      "fr": "Syrie"
    },
    "ISO2": "SY",
    "ISO3": "SYR",

    "callingCode": "963"

  },
  "TW": {
    "names": {
      "en": "Taiwan",
      "fr": "Taïwan"
    },
    "ISO2": "TW",
    "ISO3": "TWN",

    "callingCode": "886"

  },
  "TJ": {
    "names": {
      "en": "Tajikistan",
      "fr": "Tadjikistan"
    },
    "ISO2": "TJ",
    "ISO3": "TJK",

    "callingCode": "992"

  },
  "TZ": {
    "names": {
      "en": "Tanzania",
      "fr": "Tanzanie"
    },
    "ISO2": "TZ",
    "ISO3": "TZA",

    "callingCode": "255"

  },
  "TH": {
    "names": {
      "en": "Thailand",
      "fr": "Thaïlande"
    },
    "ISO2": "TH",
    "ISO3": "THA",

    "callingCode": "66"

  },
  "TL": {
    "names": {
      "en": "Timor-Leste (East Timor)",
      "fr": "Timor oriental"
    },
    "ISO2": "TL",
    "ISO3": "TLS",

    "callingCode": "670"

  },
  "TG": {
    "names": {
      "en": "Togo",
      "fr": "Togo"
    },
    "ISO2": "TG",
    "ISO3": "TGO",

    "callingCode": "228"

  },
  "TK": {
    "names": {
      "en": "Tokelau",
      "fr": "Tokelau"
    },
    "ISO2": "TK",
    "ISO3": "TKL",

    "callingCode": "690"

  },
  "TO": {
    "names": {
      "en": "Tonga Islands",
      "fr": "Îles Tonga"
    },
    "ISO2": "TO",
    "ISO3": "TON",

    "callingCode": "676"

  },
  "TT": {
    "names": {
      "en": "Trinidad and Tobago",
      "fr": "Trinité-et-Tobago"
    },
    "ISO2": "TT",
    "ISO3": "TTO",

    "callingCode": "1 868"

  },
  "TN": {
    "names": {
      "en": "Tunisia",
      "fr": "Tunisie"
    },
    "ISO2": "TN",
    "ISO3": "TUN",

    "callingCode": "216"

  },
  "TR": {
    "names": {
      "en": "Turkey",
      "fr": "Turquie"
    },
    "ISO2": "TR",
    "ISO3": "TUR",

    "callingCode": "90"

  },
  "TM": {
    "names": {
      "en": "Turkmenistan",
      "fr": "Turkménistan"
    },
    "ISO2": "TM",
    "ISO3": "TKM",

    "callingCode": "993"

  },
  "TC": {
    "names": {
      "en": "Turks and Caicos Islands",
      "fr": "Îles Turques-et-Caïques"
    },
    "ISO2": "TC",
    "ISO3": "TCA",

    "callingCode": "1 649"

  },
  "TV": {
    "names": {
      "en": "Tuvalu",
      "fr": "Tuvalu"
    },
    "ISO2": "TV",
    "ISO3": "TUV",

    "callingCode": "688"

  },
  "UG": {
    "names": {
      "en": "Uganda",
      "fr": "Ouganda"
    },
    "ISO2": "UG",
    "ISO3": "UGA",

    "callingCode": "256"

  },
  "UA": {
    "names": {
      "en": "Ukraine",
      "fr": "Ukraine"
    },
    "ISO2": "UA",
    "ISO3": "UKR",

    "callingCode": "380"

  },
  "AE": {
    "names": {
      "en": "United Arab Emirates",
      "fr": "Émirats arabes unis"
    },
    "ISO2": "AE",
    "ISO3": "ARE",

    "callingCode": "971"

  },
  "GB": {
    "names": {
      "en": "United Kingdom",
      "fr": "Royaume-Uni"
    },
    "ISO2": "GB",
    "ISO3": "GBR",

    "callingCode": "44"

  },
  "US": {
    "names": {
      "en": "United States",
      "fr": "États-Unis"
    },
    "ISO2": "US",
    "ISO3": "USA",

    "callingCode": "1"

  },
  "UY": {
    "names": {
      "en": "Uruguay",
      "fr": "Uruguay"
    },
    "ISO2": "UY",
    "ISO3": "URY",

    "callingCode": "598"

  },
  "VI": {
    "names": {
      "en": "US Virgin Islands",
      "fr": "Îles Vierges américaines"
    },
    "ISO2": "VI",
    "ISO3": "VIR",

    "callingCode": "1 340"

  },
  "UZ": {
    "names": {
      "en": "Uzbekistan",
      "fr": "Ouzbékistan"
    },
    "ISO2": "UZ",
    "ISO3": "UZ",

    "callingCode": "998"

  },
  "VU": {
    "names": {
      "en": "Vanuatu",
      "fr": "Vanuatu"
    },
    "ISO2": "VU",
    "ISO3": "VUT",

    "callingCode": "678"

  },
  "VE": {
    "names": {
      "en": "Venezuela",
      "fr": "Venezuela"
    },
    "ISO2": "VE",
    "ISO3": "VEN",

    "callingCode": "58"

  },
  "VN": {
    "names": {
      "en": "Vietnam",
      "fr": "Viêt Nam"
    },
    "ISO2": "VN",
    "ISO3": "VNM",

    "callingCode": "84"

  },
  "WF": {
    "names": {
      "en": "Wallis and Futuna",
      "fr": "Wallis-et-Futuna"
    },
    "ISO2": "WF",
    "ISO3": "WLF",

    "callingCode": "681"

  },
  "EH": {
    "names": {
      "en": "Western Sahara",
      "fr": "Sahara occidental"
    },
    "ISO2": "EH",
    "ISO3": "ESH",

    "callingCode": "212"

  },
  "YE": {
    "names": {
      "en": "Yemen",
      "fr": "Yémen"
    },
    "ISO2": "YE",
    "ISO3": "YEM",

    "callingCode": "967"

  },
  "ZM": {
    "names": {
      "en": "Zambia",
      "fr": "Zambie"
    },
    "ISO2": "ZM",
    "ISO3": "ZMB",
    "callingCode": "260"
  },
  "ZW": {
    "names": {
      "en": "Zimbabwe",
      "fr": "Zimbabwe"
    },
    "ISO2": "ZW",
    "ISO3": "ZWE",
    "callingCode": "263"
  }
};

export const locale2Language = (locale: Locale | undefined): LanguageType => {
  const language = typeof locale === "string" ? locale.split("-")[0].toLowerCase() : "en";
  return (["en", "fr"].includes(language) ? language : "en") as LanguageType;
};

export const localizeCountry = (language: LanguageType) => (country: Country): LocalizedCountry => ({
  name: country?.names[language] || country?.names.en,
  ISO2: country.ISO2,
  ISO3: country.ISO3,
  callingCode: country.callingCode
});

export const getSortedCountryList = (locale?: Locale) => {
  const language = locale2Language(locale);
  const localizer = localizeCountry(language);
  return Object.values(countries).map(localizer).sort((a: LocalizedCountry, b: LocalizedCountry) => a.name.localeCompare(b.name, language, { sensitivity: "base" }));
};

export const locale2Country = (locale?: Locale) => {
  const language = locale2Language(locale);
  const localizer = localizeCountry(language);
  const country = typeof locale === "string" ? locale.split("-")[1]?.toUpperCase() : "US";
  return Object.keys(countries).includes(country)
    ? localizer(countries[country as CountryISO2])
    : localizer(countries["US" as CountryISO2]);
};